
  import ipxRuntime$gkRYvjUGNP5jEVY2Y3qwyux4UgTu0vNVwLzq3YPHVAU from '/vercel/path0/node_modules/.pnpm/@nuxt+image@2.0.0_@vercel+functions@3.4.3_db0@0.3.4_@libsql+client@0.17.0_better-sqlite_407564c977bfba8d6f188fa7fb411769/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpeg",
    "jpg",
    "png",
    "svg",
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$gkRYvjUGNP5jEVY2Y3qwyux4UgTu0vNVwLzq3YPHVAU, defaults: {"baseURL":"https://ipx.nuxt.com"} }
    }
  }
